import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import StatsBar from "@/pages/home/components/StatsBar";
import FeatureTopic from "@/pages/home/components/FeatureTopic";
import TrendingRanking from "@/pages/home/components/TrendingRanking";
import CommentWall from "@/pages/home/components/CommentWall";
import TopicEntries from "@/pages/home/components/TopicEntries";
import Subscribe from "@/pages/home/components/Subscribe";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <FeatureTopic />
        <TrendingRanking />
        <CommentWall />
        <TopicEntries />
        <Subscribe />
      </main>
      <SiteFooter />
    </div>
  );
}